import { adEnded, adMarkers, adPaused, adPlaying, adProviderLoaded } from '../../../logic/player/player.constants';

export * from './customer/default/ads.constants';

export const DISPLAY_SHADOW_OVERLAY = false;

export const DISPLAY_AD_METADATA = false;

export const PAUSE_SIGNAL = 'pause';

export const PLAY_SIGNAL = 'play';

export const SKIP_SIGNAL = 'skip';

export const AD_ANALYTICS_TYPES = {
  begin: {
    preroll: 'prerollBegins',
    midroll: 'midrollBegins',
  },
  back: {
    preroll: 'pressBackButtonDuringPreroll',
    midroll: 'pressBackButtonDuringMidroll',
  },
  post: {
    preroll: 'postPreroll',
    midroll: 'postMidroll',
  },
};

export const TOP_BAR_ITEMS = {
  BACK: 'BACK',
};

export const BRIDGE_AD_OCEAN = 'adOcean';

export const ADS_COUNTDOWN_DEFAULT_TOTAL_DURATION = 20;

/**
 * Ad-engine events which are only mirrored, by the action created out of their arguments and/or the analytics event
 * NOTE: every event the ad bridge may emit must be listed, the bridge calls or subscribes its handlers unconditionally
 */
export const MIRRORED_AD_EVENTS = {
  onEnded: { createAction: adEnded, analyticsKey: 'adComplete' },
  onSkipped: { analyticsKey: 'adSkipped' },
  onPlaying: { createAction: adPlaying },
  onPaused: { createAction: adPaused },
  onProviderLoaded: { createAction: adProviderLoaded },
  onAdBreakListUpdate: { createAction: adMarkers },
  onFirstQuartile: { analyticsKey: 'adFirstQuartile' },
  onMidPoint: { analyticsKey: 'adMidPoint' },
  onThirdQuartile: { analyticsKey: 'adThirdQuartile' },
  onAdLoaded: {},
  onAdStopped: {},
  onAdPaused: {},
  onBreakCapping: {},
  onProviderLoading: {},
  onJinglePlaying: {},
  onJinglePaused: {},
  onJingleSkipped: {},
  onClicked: {},
  onExpandToggle: {},
};
